import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { areaValidator } from './area';
import { screenBoundaryValidator } from './screen-boundary';
import { seatLayoutBoundaryValidator } from './seat-layout-boundary';
export const seatLayoutValidator = Validator.object({
    id: Validator.number({ min: 0 }),
    screenId: nonEmptyStringValidator,
    boundary: seatLayoutBoundaryValidator,
    screenBoundary: screenBoundaryValidator,
    areas: Validator.array({ items: areaValidator })
});
